import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Avatar,
  Button,
  Divider,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setTokenClientes } from "../../Store/storages/AuthenticationStorage";
import { setBenef } from "../../Store/storages/BeneficiarioStorage";
import { getItemListContratosBeneficiario } from "../../Store/storages/ContratoBeneficiarioStorage";
import { Beneficiario } from "../../interfaces/entities/Beneficiario";
import { BeneficiarioContratoBeneficiario } from "../../interfaces/entities/BeneficiarioContratoBeneficiario";
import { TokenClientes } from "../../interfaces/entities/TokenClientes";
import { UserProps } from "../../interfaces/props/UserProps";
import {
  getBeneficiario,
  getTokenBenefClientes,
} from "../../services/LoginService";
import { getDecryptedItem } from "../../utils/EncryptedItemsManager";
import ContractSelection from "../ContractSelection";
import LoadingApp from "../LoadingApp";
import ModalFeedBack from "../ModalFeedBack";
import "./styles.css";
import { sxMenuItem } from "./sxProps";
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";
import { faUser } from "@fortawesome/pro-duotone-svg-icons";
import { endScriptsCamila } from "../../utils/CamilaUtils";

function User(props: UserProps) {
  const navigate = useNavigate();
  const { beneficiario } = props;
  const [showModalFeedBack, setShowModalFeedBack] = useState<boolean>(false);
  const [iconModal, setIconModal] = useState<"error" | "success">("error");
  const [textButtonModal, setTextButtonModal] = useState("");
  const [titleModal, setTitleModal] = useState("");
  const [subTitleModal, setSubTituloModal] = useState("");
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [listContratosBeneficiario, setListContratosBeneficiario] = useState<
    Array<BeneficiarioContratoBeneficiario>
  >([]);
  const [idUsrContr, setIdUsrContr] = useState<number>(0);
  const [showModalContract, setShowModalContract] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isLoginCpf, setIsLoginCpf] = useState(false);
  const userName = formatUserName(
    beneficiario?.nome + " " + beneficiario?.sobrenome || ""
  );
  const open = Boolean(anchorEl);
  const lastAccess = sessionStorage.getItem("lastAccess");
  const buttonTextContract: string = "Alterar contrato";

  useEffect(() => {
    validateBenefChange();
  }, []);

  const { contrastMode, contrastStyle, fontSizeStyleAccessibility } =
    useAccessibility();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickMeuCadastro = (page: string) => {
    return () => {
      handleClose();
      navigate(page);
    };
  };

  const handleAlterarBeneficiario = () => {
    handleModalContract();
  };

  function formatUserName(name: string) {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  const handleLogout = () => {
    sessionStorage.clear();
    endScriptsCamila();
    navigate("/login");
    window.location.reload();
  };

  const handleModalFeedBack = (): void => {
    setShowModalFeedBack((show) => !show);
  };

  const openModalFeedBack = (
    icon: "error" | "success",
    textButton: string,
    title: string,
    subTitle: string
  ) => {
    setIconModal(icon);
    setTextButtonModal(textButton);
    setTitleModal(title);
    setSubTituloModal(subTitle);
    handleModalFeedBack();
  };

  const handleModalContract = (): void => {
    setShowModalContract((show) => !show);
  };

  const handleClickRadioButton = (value: number) => {
    setIdUsrContr(value);
  };

  const handleChangeRadioButton = (
    value: number,
    e: React.KeyboardEvent<HTMLButtonElement>
  ) => {
    if (e?.key === " ") {
      e.preventDefault();
      setIdUsrContr(value);
    }
  };

  const handleSelectContract = async () => {
    setShowLoading(true);
    var selectedContract = listContratosBeneficiario.find(
      (contratoBeneficiario) => contratoBeneficiario.idUsrContr === idUsrContr
    );
    let newUser = selectedContract?.codAntigoUsrDescr || ""; //Novo token deve ser gerado a partir da carteira que será manipulada
    let pass = getDecryptedItem("benefSecret");
    await tokenGenerate(newUser, pass);
    setShowLoading(false);
  };

  const tokenGenerate = async (userName: string, password: string) => {
    var dataError: Error;
    const resultTokenClientes = await getTokenBenefClientes(userName, password);
    if (resultTokenClientes?.status !== 200) {
      dataError = resultTokenClientes?.data;
      openModalFeedBack(
        "error",
        "Voltar",
        "Erro ao alterar usuário",
        dataError.message
      );
    } else {
      var dataTokenClientes: TokenClientes = resultTokenClientes.data;
      setTokenClientes(dataTokenClientes);
      await getAndStoreBenef();
      window.location.reload();
    }
  };

  const getAndStoreBenef = async () => {
    const resultBenef = await getBeneficiario();
    if (resultBenef?.status !== 200) {
      var dataError: Error = resultBenef?.data;
      openModalFeedBack(
        "error",
        "Voltar",
        "Erro ao efetuar login",
        dataError.message
      );
    } else {
      var beneficiario: Beneficiario = resultBenef.data.dados;
      setBenef(beneficiario);
      navigate("/home");
    }
  };

  const validateBenefChange = () => {
    let locListContratosBenef = getItemListContratosBeneficiario();
    if (locListContratosBenef.length > 1) {
      setListContratosBeneficiario(locListContratosBenef);
      let userLogin = getDecryptedItem("benefKey");
      let isLoginCpf: boolean =
        userLogin.length === 11 && !userLogin.startsWith("000");
      setIsLoginCpf(isLoginCpf);
    }
  };

  return (
    <div className="width-100-user">
      <LoadingApp showLoading={showLoading} />
      <div>
        <Button
          className="user-button"
          onClick={handleClick}
          size="small"
          endIcon={
            <FontAwesomeIcon
              className="user-name-icon"
              icon={open ? faChevronUp : faChevronDown}
            />
          }
        >
          {userName && (
            <Avatar
              sx={{
                bgcolor: contrastMode ? "yellow" : "#dddcdc",
              }}
            >
              <FontAwesomeIcon
                icon={faUser}
                color={"#4C4C4C"}
                className={`${contrastMode && "user-icon-contrast"}`}
              />
            </Avatar>
          )}
          <Typography className="user-name" style={fontSizeStyleAccessibility}>
            {userName}
          </Typography>
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          sx={{ "& .MuiMenu-paper": contrastStyle }}
          MenuListProps={{
            autoFocus: false,
            disableListWrap: true,
          }}
        >
          <div className="div-user-menu-item" tabIndex={-1} aria-hidden="true">
            <MenuItem
              disabled
              className={`last-access ${contrastMode && "contrast-font"}`}
              style={fontSizeStyleAccessibility}
            >
              último acesso: {lastAccess}
            </MenuItem>
          </div>
          <Divider />
          <div className="div-user-menu-item">
            <MenuItem
              sx={sxMenuItem}
              style={{ ...contrastStyle, ...fontSizeStyleAccessibility }}
              onClick={handleClickMeuCadastro("/meuPlano/meuCadastro")}
              tabIndex={0}
            >
              Meu cadastro
            </MenuItem>
            {isLoginCpf && (
              <MenuItem
                sx={sxMenuItem}
                style={{ ...contrastStyle, ...fontSizeStyleAccessibility }}
                onClick={() => handleAlterarBeneficiario()}
                tabIndex={0}
              >
                Alterar contrato
              </MenuItem>
            )}
            <MenuItem
              sx={sxMenuItem}
              style={{ ...contrastStyle, ...fontSizeStyleAccessibility }}
              onClick={handleLogout}
              tabIndex={0}
            >
              Sair
            </MenuItem>
          </div>
        </Menu>
      </div>
      <ModalFeedBack
        showModal={showModalFeedBack}
        handleShowModal={handleModalFeedBack}
        icon={iconModal}
        textButton={textButtonModal}
        title={titleModal}
        subTitle={subTitleModal}
        handleButtonModal={handleModalFeedBack}
      />
      <ContractSelection
        idUsrContr={idUsrContr}
        handleRadioButton={handleChangeRadioButton}
        showModal={showModalContract}
        handleShowModal={handleModalContract}
        handleSelectButton={handleSelectContract}
        listaBeneficiarios={listContratosBeneficiario}
        buttonText={buttonTextContract}
        handleClickRadioButton={handleClickRadioButton}
      />
    </div>
  );
}

export default User;
